// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"056fe136","455":"9d003ac2","488":"8d818ea2","977":"924bb91e"}[chunkId] + ".chunk.js";
};